<template>
	<div class="hidden-box"></div>
</template>

<script>
	export default {
		name: "HiddenReflector",

		mounted() {
			// 将 JavaScript 函数暴露给 Android
			window.sendViaWebSocket = this.sendViaWebSocket;
		},

		methods: {
			sendViaWebSocket(msgId, content) {
				console.log("H5 确实收到了 Android 的指令:", content);
				// 原封不动地把 id 和内容回调给 Android 原生
				window.AndroidGateway.postRawMessage(msgId, content);
			},
		},

		beforeDestroy() {
			// 当组件销毁时，及时解绑全局 window 函数，防止后台内存堆积
			window.sendViaWebSocket = null;
			window.renderNewMessage = null;
		}
	};
</script>

<style scoped>
	/* 隐藏组件，不需要任何样式 */
	.hidden-box {
		display: none;
	}
</style>